
export const TimeUtilsHelper = {
    /**
     * Returns time in seconds for expiration based on string value passed in.
     *
     * @param expiresIn
     */
    parseExpiresIn(expiresIn) {
        // if AAD did not send "expires_in" property, use default expiration of 3599 seconds, for some reason AAD sends 3599 as "expires_in" value instead of 3600
        if (!expiresIn) {
            expiresIn = "3599";
        }

        return parseInt(expiresIn, 10);
    },

    /**
     * return the current time in Unix time. Date.getTime() returns in milliseconds.
     */
    dateNowNumber() {
        return Math.round(new Date().getTime() / 1000.0);
    },

    /**
     * return the time in Unix time. returns in milliseconds.
     */
    thisDateNumber(thisDateValue) {
        if ((!thisDateValue) || (!thisDateValue.getTime)) return 0;
        
        return Math.round(thisDateValue.getTime() / 1000.0);
    }
}